import styled from 'styled-components';

import { Button } from 'common/interaction';

export const CalendarNavBarContainer = styled.div`
  position: absolute;
  display: flex;
  right: 14px;
  column-gap: 5px;
`;

export const CalendarButton = styled(Button)`
  width: 40px;
  height: 40px;
  padding: 5px;

  svg {
    height: 14px;
    width: 16px;
    fill: ${({ theme }) => theme.colors.primaryDeep};
  }
`;
